import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const EvnModule = {
  namespaced: true,
  state: {
    view: 'current',
    currentEvn: '',
    requestFailed: false
  },
  actions: {
    async saveEvnSettings ({ commit, state }, { selectedEvn, nextStep }) {
      state.currentEvn = selectedEvn
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation changeEvnSettings ($evnConfiguration: EvnSettingsInput!){
          evnConfiguration(evnConfiguration: $evnConfiguration) {
            success
          }
        }`,
        variables: {
          evnConfiguration: {
            evn: selectedEvn
          }
        }
      }).then((response) => {
        if (response.data.evnConfiguration.success === true) {
          commit('Transaction/removeTransactionId', 'changeEvnSettings', { root: true })
          commit('addMessage', { type: 'success', message: 'Die Evn-Einstellungen wurden geändert.' }, { root: true })
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async changeConsent ({ commit, state }, { selectedEvn, nextStep }) {
      state.currentEvn = selectedEvn
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation changeEvnSettings ($evnConfiguration: EvnSettingsInput!){
          evnConfiguration(evnConfiguration: $evnConfiguration) {
          success
        }
        }`,
        variables: {
          evnConfiguration: {
            evn: selectedEvn
          }
        }
      }).then((response) => {
        if (response.data.evnConfiguration.success === true) {
          commit('Transaction/removeTransactionId', 'changeEvnSettings', { root: true })
          commit('addMessage', { type: 'success', message: 'Die Evn-Einstellungen wurden geändert.' }, { root: true })
        }
      }).catch((error) => {
        commit('setFailedState', true)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    changeStep (state, newView) {
      state.view = newView
    },
    saveEvnLocal (state, currentEvn) {
      state.currentEvn = currentEvn
    },
    setFailedState (state, status) {
      state.requestFailed = status
    }
  },
  getters: {
    getStep: state => {
      return state.view
    },
    getCurrentEvn: state => {
      return state.currentEvn
    }
  }
}

export {
  EvnModule
}
